// @flow
import $ from 'jquery';

/**
 * JS vymazání obsahu inputu pro datepicker
 */
export default (): void => {

	$.fn.clearDatepicker = function () {
		const cBtns = $('.datepickerClear');

		cBtns.each(function () {
			let t = $(this);
			let cInput = $('#'+t.data("clear"));
			//console.log("cInput");
			//console.log(cInput);

			if (cInput.val().length != 0) {
				t.removeClass('hidden');
				t.on('click', function (e) {
					e.preventDefault();
					const self = $(e.target).closest('.datepickerClear'),
						clearInput = $("#" + self.data("clear"));
					if (clearInput.val().length != 0) {
						clearInput.val('').trigger("change");
					}
				});
			} else {
				if(!t.hasClass('hidden')) {
					t.addClass('hidden');
				}
			}
		});
	};

	$.fn.clearDatepicker();

	$(document).on('afterContentsReplaced', function() {
		$.fn.clearDatepicker();
	});

};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/ClearDatepicker.js